export default "__VITE_ASSET__DjGh5EUs__"